import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Inicio from './components/Inicio';
import Edicion1 from './components/Edicion1';
import PoliticaDatos from './components/PoliticaDatos';
import './index.css';

function App() {
  return (
    <Router>
      <div className="App">

        {/* Barra de navegación */}
        <Navbar />

        {/* Contenido */}
        <div className="main">
          <Routes>
            <Route path="/" element={<Inicio />} /> {/* Página de inicio */}
            <Route path="/edicion1" element={<Edicion1 />} /> {/* Página de ediciones */}
            <Route path="/politica-datos" element={<PoliticaDatos />} /> {/* Página de ediciones */}

            {/* <Route path="/candidatura" element={<Candidatura />} */} {/* Página para enviar candidatura */}
            {/* <Route path="/votaciones" element={<Votaciones />} /> */} {/* Página para votar */}


            {/* <Route path="/registro" element={<Register />} /> */}
            {/* <Route path="/contacto" element={<Contacto />} /> */}
          </Routes>
        </div>

        {/* Footer */}
        <Footer />

      </div>
    </Router>
  );
}

export default App;